import { signal } from "@angular/core";
import { User } from "./user.model";
import { UserStore } from "./user.store";

/**
 * A store holding the in-memory verdict and session id of the current OIDC session verification.
 * Session-id persistence is owned by AuthService; this store never reads or writes storage.
 */
export class UserStoreOidcImpl implements UserStore {
  private readonly session = signal<{ authenticated: boolean; sessionId: string }>({
    authenticated: false,
    sessionId: "",
  });

  /** @return The verification verdict and the verified session id, and nothing else */
  public get(): User {
    const { authenticated, sessionId } = this.session();
    return { authenticated, sessionId };
  }

  /** @return Whether the backend verified the session in the current page load */
  public isUserValid(): boolean {
    return this.session().authenticated;
  }

  /** @return Whether the session still has to be verified; auth is implicitly required for OIDC */
  public isMissingRequiredUser(): boolean {
    return !this.session().authenticated;
  }

  /** Updates the current session in memory without changing persistent storage. */
  public set(user: User): void {
    this.session.set({
      authenticated: user.authenticated === true,
      sessionId: user.sessionId ?? "",
    });
  }
}
